module.exports = __webpack_public_path__ + "img/portaventura_water_ride.dee8e592.jpeg";